import { aludraApi } from 'Api/axios'

const mdl6 = {
  promotion: '/mdl06/promotion/search',
}

export const getPromotionService = async payload => {
  return aludraApi.post(mdl6.promotion, payload)
}
